import { Inline, Stack, Text, textColors, textVariants, vars } from '@etg/wings';
import { CheckCircle } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import { useProperty, useTranslation } from '@eti/providers';
import { price as priceUtils } from '@eti/utils';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import { screenReaderOnly } from '../../common/utils/styles';
import { getAdditionalProductInfo, getFormattedPrice, getPriceText } from '../utils/utils';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const priceInformationStyles = css`
  border-bottom: 1px solid ${vars.colors.divider};
  display: flex;
  flex-direction: column;
  padding: 16px 0;
`;
const includedProductStyles = css`
  padding-top: 16px;
`;
const checkCircleStyles = css`
  flex-shrink: 0;
  margin-top: 2px;
`;
const lineStrikeStyle = css`
  text-decoration: line-through;
`;
const texts = {
  screenReaderIncludedProductsText: 'ScreenReader.Product.ETG.Fares.Included.Text',
  totalPriceText: 'Product.FlexibleTicket.Bundle.Price.Text',
  pricePerTravelerText: 'Price.Per.Person',
  pricePerTravelerAndBoundText: 'Product.ETG.Fares.Price.Per.Person.And.Bound.Text',
  whenAvailableText: 'Product.ETG.Fares.PartialAvailable.Information.Text',
  discountedPriceText: 'ScreenReader.Product.ETG.Fares.Discounted.Price.Text',
  originalPriceText: 'ScreenReader.Product.ETG.Fares.Original.Price.Text'
};
const piecesBaggageText = 'Product.BaggagePerTraveler.Pieces';
const weightValuesBaggageText = 'Product.BaggagePerTraveler.Weight';
const EtgFaresCardContent = ({
  bounds,
  hasDiscount,
  numberOfTravelersWithoutInfants,
  optionIndex,
  option
}) => {
  const {
    p
  } = useProperty();
  const {
    t
  } = useTranslation();
  const pricePerTravelerAndBound = p('ETG.Fares.Price.Per.Person.And.Bound.Enabled');
  const pricePerTraveler = p('Bundle.Overlay.Price.Per.Person.Enabled');
  const {
    totalPriceText,
    discountedPriceText,
    originalPriceText,
    whenAvailableText,
    screenReaderIncludedProductsText,
    pricePerTravelerAndBoundText,
    pricePerTravelerText
  } = getTranslatedTexts(texts, t);
  const formattedPrice = price => getFormattedPrice(price, bounds, numberOfTravelersWithoutInfants, pricePerTravelerAndBound, pricePerTraveler);
  const priceText = getPriceText(bounds, pricePerTravelerAndBound, pricePerTraveler, totalPriceText, pricePerTravelerText, pricePerTravelerAndBoundText);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      className: priceInformationStyles,
      id: `option-${optionIndex}-price-content`,
      spacing: 4,
      children: [hasDiscount && /*#__PURE__*/_jsxs(Text, {
        as: "p",
        className: lineStrikeStyle,
        color: textColors.SECONDARY,
        children: [/*#__PURE__*/_jsx("span", {
          className: screenReaderOnly,
          children: `${originalPriceText}:
                          ${priceUtils.replaceWithCurrencyName(formattedPrice(option.originalPrice))}`
        }), /*#__PURE__*/_jsxs("span", {
          "aria-hidden": "true",
          children: ["+", formattedPrice(option.originalPrice)]
        })]
      }), /*#__PURE__*/_jsxs(Text, {
        as: "p",
        variant: textVariants._24_EMPHASIZED,
        children: [/*#__PURE__*/_jsx("span", {
          className: screenReaderOnly,
          children: hasDiscount ? `${discountedPriceText}:
                        ${priceUtils.replaceWithCurrencyName(formattedPrice(option.priceRaw))}` : `${priceUtils.replaceWithCurrencyName(formattedPrice(option.priceRaw))}`
        }), /*#__PURE__*/_jsxs("span", {
          "aria-hidden": "true",
          children: ["+", formattedPrice(option.priceRaw)]
        })]
      }), /*#__PURE__*/_jsx(Text, {
        children: priceText
      })]
    }), /*#__PURE__*/_jsxs(Stack, {
      className: includedProductStyles,
      id: `included-products-content-${optionIndex}`,
      children: [/*#__PURE__*/_jsx(Text, {
        className: screenReaderOnly,
        children: `${option.features.length} ${screenReaderIncludedProductsText}:`
      }), /*#__PURE__*/_jsx(Stack, {
        as: "ul",
        spacing: 4,
        children: option.features.map((feature, index) => /*#__PURE__*/_jsxs(Inline, {
          as: "li",
          noWrap: true,
          spacing: 8,
          children: [/*#__PURE__*/_jsx(CheckCircle, {
            "aria-hidden": true,
            className: checkCircleStyles,
            color: vars.colors.signal.positive.foreground,
            size: 16,
            weight: "fill"
          }), /*#__PURE__*/_jsxs(Text, {
            as: "bdi",
            children: [feature.name, ' ', getAdditionalProductInfo(t, feature, bounds, piecesBaggageText, weightValuesBaggageText, whenAvailableText)]
          })]
        }, `${option.title}-feature-${index}`))
      })]
    })]
  });
};
export default EtgFaresCardContent;
//# sourceMappingURL=EtgFaresCardContent.js.map